import React from 'react';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper } from '@mui/material';

// Generic two-column table shared across legal pages — used for data
// categories, processing purposes, retention schedules, and any similar
// "label + description" table. `rows` is [{ label, description }, ...].
const TwoColumnTable = ({ columnHeaders = ['Category', 'Examples / description'], rows }) => (
  <TableContainer component={Paper} variant="outlined" sx={{ my: 1 }}>
    <Table size="small">
      <TableHead>
        <TableRow>
          <TableCell sx={{ fontWeight: 600, width: '32%' }}>{columnHeaders[0]}</TableCell>
          <TableCell sx={{ fontWeight: 600 }}>{columnHeaders[1]}</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {rows.map((row) => (
          <TableRow key={row.label}>
            <TableCell sx={{ verticalAlign: 'top', fontWeight: 500 }}>{row.label}</TableCell>
            <TableCell sx={{ verticalAlign: 'top' }}>{row.description}</TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  </TableContainer>
);

export default TwoColumnTable;
